const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'absence',
        preventClearOnCancel: true,
    },

    methods: {

        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			{} - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            this.updateView(fieldData || {})
        },

        updateView(fieldData, isInit = false){
            if(!this.config.isReady) return;

            fieldData = fieldData || {}

            // employee vs contractor
            let $resetAutoComplete
            if(fieldData.fieldCode === 'contractorID' && fieldData.fieldValue){
                $resetAutoComplete = this.$.find('[data-field-code="employeeID"]')
            } else if(fieldData.fieldCode === 'employeeID' && fieldData.fieldValue){
                $resetAutoComplete = this.$.find('[data-field-code="contractorID"]')
            }

            if(($resetAutoComplete || {}).length > 0){
                const resetAutoComplete = getComponent($resetAutoComplete)
                if(resetAutoComplete){
                    resetAutoComplete.unChoose()
                }
            }

            // correct timeRange if necessary
            const absenceType = this.getFieldValue('type')
            const lastAbsenceType = `${this.model.lastAbsenceType}`

            if(isInit || fieldData.fieldCode === 'type'){
                this.model.lastAbsenceType = absenceType
                const $timeRange = this.$.find('.fieldOf_timeRange > .base_form_fields_period-air')
                if(($timeRange || {}).length > 0){
                    const timeRange = getComponent($timeRange)
                    if(timeRange){
                        // update timeRange if necessary
                        if(!isInit){
                            let from, to
                            if(['restWish', 'notAvailable'].includes(lastAbsenceType) && !(['restWish', 'notAvailable'].includes(absenceType))) {
                                if(timeRange.model.dateFrom){
                                    from = utils.moment(timeRange.model.dateFrom).startOf('day').format()
                                }
                                if(timeRange.model.dateTo){
                                    to = utils.moment(timeRange.model.dateTo).startOf('day').format()
                                }
                            }
                            if(from || to){
                                timeRange.onChange(from, to)
                            }
                        }

                        // update config
                        const configByAbsenceType = timeRange.model.config.configByAbsenceType || {}
                        timeRange.updateFieldConfig(utils.simpleMerge(
                            configByAbsenceType.base || {},
                            configByAbsenceType[absenceType] || configByAbsenceType.default || {},
                        ))
                    }
                }
            }

            // correct confirmation if necessary
            const $statusField = this.$.find('.fieldOf_status')
            const statusToggle = getComponent($statusField.find('> .base_form_fields_toggle'), true)
            if($statusField.length > 0 && statusToggle){
                if(!this.hasAccessTo('bo_absence:usage:confirmGranted')){
                    statusToggle.setDisabledValues({
                        confirmed: true
                    })
                }

                if(absenceType === 'notAvailable'){
                    $statusField.hide()
                    statusToggle.select('requested')
                } else if(lastAbsenceType === 'notAvailable') {
                    $statusField.show()
                    statusToggle.select('requested')
                }
            }
        },
    },

    hooks: {
        _postAttach($element, options){
            this.updateView(undefined, true)
        }
    }
}